var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdpApplicationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#161616",
  d: "m21.499 9.085-6.792-6.792A1 1 0 0 0 14 2H4c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h8v-2H4V4h8v6c0 1.102.897 2 2 2h6.292c.693 0 1.312-.414 1.577-1.054.266-.64.12-1.37-.37-1.861M14 10V4.414L19.585 10zM23 14v7h7v-7zm5 5h-3v-3h3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#161616",
  d: "M21 18h-7v12h12v-7h-5zm-2 10h-3v-3h3zm5-3v3h-3v-3zm-8-2v-3h3v3z"
})));
export default SvgIdpApplicationIcon;